import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/reset.css";
import "./global-styles.css";

const changeFavicon = (faviconUrl) => {
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "icon";
  link.href = faviconUrl;
  document.getElementsByTagName("head")[0].appendChild(link);
};

const setDynamicTitleAndFavicon = () => {
  const currentDomain = window.location.hostname;
  const validDomains = ["localhost", "vudio", "vyumi"];
  const isVudioDomain = validDomains.some((domain) =>
    currentDomain.includes(domain)
  );

  if (currentDomain.includes("getepik")) {
    document.title = "Epik Dashboard";
    changeFavicon("https://cdn.vyumi.ai/getepik/fev.jpg");
  } else if (isVudioDomain) {
    document.title = "Vyumi - Dashboard";
    changeFavicon("/img/VyumiLogo_1.png");
  } else {
    document.title = "Vyumi - Dashboard";
    changeFavicon("/img/VyumiLogo_1.png");
  }
};

setDynamicTitleAndFavicon();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
